import React from 'react';
import PropTypes from 'prop-types';
import paths from './paths';
import Face from '../common/face/Face';
import getUniqueId from '../../utils/getUniqueId';
import Wrapper from '../common/wrapper/Wrapper';

var Mug = function Mug(_ref) {
  var size = _ref.size,
      color = _ref.color,
      mood = _ref.mood,
      className = _ref.className;
  return /*#__PURE__*/React.createElement(Wrapper, {
    className: className
  }, /*#__PURE__*/React.createElement("svg", {
    width: size * 1.5,
    height: size,
    viewBox: "0 0 172 115",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kawaii-mug"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kawaii-mug__body",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: paths.shape,
    id: "kawaii-mug__shape",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: paths.shadow,
    id: "kawaii-mug__shadow",
    fill: "#000",
    opacity: ".1"
  })), /*#__PURE__*/React.createElement(Face, {
    mood: mood,
    transform: "translate(71 42)",
    uniqueId: getUniqueId()
  }))));
};

Mug.propTypes = {
  /**
   * Size of the width
   * */
  size: PropTypes.number,
  mood: PropTypes.oneOf(['sad', 'shocked', 'happy', 'blissful', 'lovestruck', 'excited', 'ko']),

  /**
   * Hex color
   */
  color: PropTypes.string
};
Mug.defaultProps = {
  size: 170,
  mood: 'blissful',
  color: '#A6E191'
};
export default Mug;